import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { Scrollbars } from "react-custom-scrollbars";
import { connect } from "react-redux";
import Employee from "./employee";
import {
  setEmployeeHasAbsence,
  removeEmployeeHasAbsence,
  toggleShack,
  setMileage,
  updateEmployeeTimeRegistration,
  updateEmployeeAddTimeRegistration,
  updateEmployeeBreak,
} from "./actions";

class Employees extends Component {
  render() {
    const { employees, checkInCheckOutMode, dispatch, userAcks } = this.props;
    let employeeNodes = employees.map((employee, index) => {
      let disabled = userAcks !== undefined;
      if (disabled) {
        const id = employee
          ? employee.id
            ? employee.id.toLowerCase()
            : ""
          : "";
        if (userAcks[id] && userAcks[id].safety && userAcks[id].understood) {
          disabled = false;
        }
      }
      //ad
      return (
        <div key={employee.id} style={styles.employeeContainer}>
          <Employee
            disabled={disabled}
            checkInCheckOutMode={checkInCheckOutMode}
            employee={employee}
            index={index}
            updateEmployeeBreak={(h) => dispatch(updateEmployeeBreak(index, h))}
            setEmployeeHasAbsence={(val) =>
              dispatch(setEmployeeHasAbsence(index, val))
            }
            removeEmployeeHasAbsence={() =>
              dispatch(removeEmployeeHasAbsence(index))
            }
            toggleShack={(shack) => dispatch(toggleShack(index, shack))}
            setMileage={(mileage) => dispatch(setMileage(index, mileage))}
            updateEmployeeTimeRegistration={(
              timeRegistrationIndex,
              typeOf,
              val
            ) =>
              dispatch(
                updateEmployeeTimeRegistration(
                  index,
                  timeRegistrationIndex,
                  typeOf,
                  val
                )
              )
            }
            updateEmployeeAddTimeRegistration={() =>
              dispatch(updateEmployeeAddTimeRegistration(index))
            }
          />
        </div>
      );
    });

    return (
      <div style={styles.container}>
        <Scrollbars
          style={{ height: "100%", width: "100%" }}
          renderTrackHorizontal={(props) => (
            <div
              {...props}
              className="track-horizontal"
              style={{ display: "none" }}
            />
          )}
          renderThumbHorizontal={(props) => (
            <div
              {...props}
              className="thumb-horizontal"
              style={{ display: "none" }}
            />
          )}
        >
          {employeeNodes}
        </Scrollbars>
      </div>
    );
  }
}

var styles = {
  container: {
    height: "100%",
  },
  employeeContainer: {
    paddingRight: "12px",
  },
};

const selectProps = (state) => {
  return {
    ...state.dailyReportEmployeesReducer,
  };
};
Employees.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string,
      }),
      mileage: PropTypes.number.isRequired,
      shack: PropTypes.bool.isRequired,
      timeRegistrations: PropTypes.arrayOf(
        PropTypes.shape({
          hours: PropTypes.number.isRequired,
          nightHours: PropTypes.number.isRequired,
          employeeFunction: PropTypes.string,
        })
      ).isRequired,
    })
  ).isRequired,
};
export default connect(selectProps)(Radium(Employees));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Employees/index.jsx